<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>

        <d-col md="6" class="form-group">
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">{{ $t('settings.roles.card.title') }}</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <d-list-group>
                  <d-list-group-item v-for="(row, index) in rolesList" :key="index" class="d-flex px-3">
                    <span class="text-semibold text-fiord-blue col pl-0">
                      <d-input
                        v-model="row.name"
                        class="input-hidden"
                        @change="capitalizeInput(index)"
                        :placeholder="$t('settings.roles.placeholder')"
                      />
                    </span>
                    <span class="ml-auto text-right text-semibold col-auto px-0">
                      <i class="fas fa-plus" @click="addRow()" v-if="index+1 == rolesList.length"></i>
                      <i class="fas fa-minus" @click="removeRow(index)"></i>
                      <i class="fas fa-save" @click="saveRoles(index)"></i>
                    </span>
                  </d-list-group-item>
                </d-list-group>
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>

      </d-row>

    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy, capitalize } from '_utils/string';
import AccessControlService from '_services/rest/modules/accessControl';
import { OPTION } from '../SettingsModel';

export default {
  name: 'roles-form',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles && roles.length > 0) {
        return roles;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getRoles',
      'addRole',
    ]),
    addRow() {
      return this.addRole({ ...OPTION });
    },
    capitalizeInput(index) {
      this.rolesList[index].name = capitalize(this.rolesList[index].name);
    },
    checkEmptyOptions() {
      if (this.rolesList.length === 0) {
        this.rolesList.push({ ...OPTION });
      }
    },
    formatSlug(option) {
      option.slug = stringfy(option.name);
    },
    getOptions() {
      this.getRoles();
    },
    removeRow(index) {
      AccessControlService.removeRoles(this.rolesList[index].id)
        .then(() => {
          this.rolesList.splice(index, 1);
          this.checkEmptyOptions();
          this.activeAlert({
            message: this.$t('settings.alert.roleSaved'),
            theme: 'success',
          });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    saveRoles(index) {
      this.formatSlug(this.rolesList[index]);
      AccessControlService.saveRoles(this.rolesList[index])
        .then(() => {
          this.activeAlert({
            message: this.$t('settings.alert.roleSaved'),
            theme: 'success',
          });
          this.getRoles();
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';

.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  &:focus {
    box-shadow: none;
    border: 0;
  }
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
